// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_REPORT_POST = "nahl\u00e1senie pr\u00edspevku";
export const ACTION_TO_SUBSCRIBE_TOPIC = "odoberanie diskusnej skupiny";
export const PROBLEM_WAS_REPORTED_THANK_YOU = "Pr\u00edspevok bol nahl\u00e1sen\u00fd. \u010eakujeme.";
